import React, { useState, createContext, useContext } from 'react';

const ToastContext = createContext();

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        // Fallback if used outside provider (shouldn't happen in this setup)
        return { 
            addToast: (msg, type) => console.log(type, msg),
            success: (msg) => console.log('success', msg),
            error: (msg) => console.log('error', msg)
        };
    }
    return context;
};

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);

    const addToast = (message, type = 'info') => {
        const id = Date.now().toString() + Math.random().toString(36).substring(2, 9);
        setToasts(prev => [...prev, { id, message, type }]);
        
        // Auto-remove toast after 3 seconds
        setTimeout(() => {
            setToasts(prev => prev.filter(t => t.id !== id));
        }, 3000);
    };

    const success = (message) => addToast(message, 'success');
    const error = (message) => addToast(message, 'error');

    return (
        <ToastContext.Provider value={{ addToast, success, error }}>
            {children}
            {/* Toast Container */}
            <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
                {toasts.map(toast => (
                    <div 
                        key={toast.id} 
                        className={`px-4 py-3 rounded-lg shadow-xl font-bold text-sm text-white pointer-events-auto flex items-center gap-2 transition-all duration-300 animate-fade-in-up ${
                            toast.type === 'success' ? 'bg-gray-900' : 
                            toast.type === 'error' ? 'bg-red-600' : 
                            'bg-blue-600'
                        }`}
                    >
                        {toast.type === 'success' && <span>✅</span>}
                        {toast.type === 'error' && <span>🚨</span>}
                        {toast.message}
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}